import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import { get, map } from "lodash";
import CloseIcon from "../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import Button from '@material-ui/core/Button';
import CustomSelect from "../Common/CustomSelect";
import CustomInput from "../Common/CustomInput";
import colors from "../../assets/style/colors";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { fetchGet, fetchPost } from "../../api/fetch";
import { connect } from "react-redux";
import Dialog from '@material-ui/core/Dialog';
import ZoneError from "./ZoneError";
import MessageDialog, { MessageStatus } from "../Common/MessageDialog";
import { ZONE_TYPE, ZONE_TYPES_WITH_MULTI_CREATE, ZONE_ATTR, ZONE_RESPONSIBILITY_CENTER_OPTIONS } from "../../constants/zones";
import { UNIT_OF_MEASURE } from "../../constants/attributes";
import Loader from "../Common/Loader";

const styles = {
    container: {
        width: 353,
    },
    container2: {
        width: 353,
    },
    close: {
        float: "right",
        margin: 10,
        display: "inline",
        top: -43
    },
    title: {
        fontSize: 14,
        color: colors.black87,
        fontWeight: 400,
        display: "table",
        margin: "0 auto",
        marginTop: 15
    },
    typeFont: {
        fontSize: 14,
        fontWeight: 500,
    },
    mainDiv: {
        marginLeft: 23,
        marginTop: 30
    },
    radioLabel: {
        fontWeight: 500,
        color: colors.black87,
        fontSize: "1em",
        marginRight: "20px",
    },
    buttons: {
        display: "table",
        margin: "0 auto",
        left: -20
    },
    commonAttributes: {
        fontSize: 14,
        color: colors.black54,
        fontStyle: "italic",
        fontWeight: 440
    },
    commonAttributes2: {
        fontSize: 14,
        color: colors.black54,
        fontWeight: 440,
        marginRight: 30
    },
    hrLine: {
        top: -22,
        height: 0,
        marginBottom: 0
    },
    volumeSubHeaders: {
        marginLeft: 20
    },
    volumeInput: {
        width: 55,
        padding: 5,
        border: "1px solid #cccccc",
        marginRight: 30
    }
};

const ZoneCreation = withStyles(styles)((props) => {
    const {
        language,
        handleClose,
        classes,
        currentNode = null,
        onExpand,
        expandedZones,
        unitMeasurements,
        goTo,
        setTreeDirty
    } = props;

    const [zoneTypeSelected, selectZoneType] = React.useState();
    const [zone_name, setZoneName] = React.useState("");
    const [unitSelected, setUnitSelected] = React.useState();
    const [selectedResponsibilityCenter, setSelectedResponsibilityCenter] = React.useState();
    const [zoneError, setZoneError] = React.useState(false);
    const [binRadio, setbinRadio] = React.useState("0");
    const [zonesMenu, setZonesMenu] = React.useState([]);
    const [numBins, setNumBins] = React.useState(1);
    const [messageDialog, setOpenMessage] = React.useState(false); // Boolean
    const [message, setMessage] = React.useState(); // String
    const [messageStatus, setMessageStatus] = React.useState(); // Holds MessageStatus object.
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const [zone_attributes, setZoneAttributes] = React.useState([]);

    const attribute_blacklist = [];

    React.useEffect(() => {
        // Clear the item and attributes and fetch the item and the tree.
        try {
            fetchZones()
        } catch (error) {
            console.log(error)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const fetchZones = async () => {
        try {
            var res = await fetchGet(`/zone_types?active=true`)
            var zones = []
            for (let i in res) {
                if (res[i]["id"] >= ZONE_TYPE.SECTOR) {
                    zones.push({ id: res[i]["id"], name: res[i][`name_${language}`] })
                }

            }
            setZonesMenu(zones)

        } catch (e) {
            console.log(e);
        }
    }

    const getZoneAttributes = async (zone_id) => {
        try {
            var res = await fetchGet(`/zone_types/${zone_id}/attributes`)
            var attributes = []

            for (let i in res) {
                // setup any default values
                if (res[i]['id'] === ZONE_ATTR.UNIT_OF_MEASURE) {
                    setUnitSelected(UNIT_OF_MEASURE.IN);
                }
                //check for blacklisted attributes
                if (!attribute_blacklist.includes(res[i]["id"])) {
                    attributes.push(res[i])
                }
            }
            setZoneAttributes(attributes.filter(a => a.app_display_main_page))
        } catch (error) {
            console.log(error)
        }
    }


    const handleZoneCreation = async () => {
        setIsSubmitting(true);
        try {
            var attributes = []
            var depth = false;
            var height = false;
            var width = false;
            var unitSet = false;
            for (let i in zone_attributes) {
                var attr = zone_attributes[i]
                var attr_id = attr["id"]
                var attribute_value;
                if (attr_id === ZONE_ATTR.UNIT_OF_MEASURE) {
                    attribute_value = parseInt(unitSelected)
                } else if (attr_id === ZONE_ATTR.RESPONSIBILITY_CENTER) {
                    attribute_value = selectedResponsibilityCenter
                } else {
                    attribute_value = document.getElementById(attr_id).value
                }

                if (attr_id === 252 && attribute_value) {
                    depth = true;
                }
                if (attr_id === 253 && attribute_value) {
                    width = true;
                }
                if (attr_id === 254 && attribute_value) {
                    height = true;
                }
                if (attr_id === 255 && attribute_value) {
                    unitSet = true
                }

                if (attr['required'] && attribute_value === "") {
                    setMessage(attr[`name_${language}`] + " " + I18n.get("is_required"));
                    setMessageStatus(MessageStatus.WARNING);
                    setOpenMessage(true);
                    return
                }
                if (attr["data_type"] === "integer") {
                    attribute_value = parseInt(attribute_value)
                }
                if (attr["data_type"] === "float") {
                    attribute_value = parseFloat(attribute_value)
                }
                attributes.push({
                    "id": attr_id,
                    "value": attribute_value
                })
            }


            if (!([depth, width, height, unitSet].every((val, i, arr) => val === arr[0]))) {
                setMessage(I18n.get("unit_required"));
                setMessageStatus(MessageStatus.WARNING);
                setOpenMessage(true);
                return
            }
            var zone_id = zoneTypeSelected
            var parent_zone_id = currentNode["id"]
            var company_id = currentNode["company_id"]
            var site_id = currentNode["site_id"]
            var one;
            if (binRadio === "0") {
                one = true;
            } else {
                one = false;
            }
            var multiple = parseInt(numBins);
            var name;
            if (zone_name === "") {
                name = null;
            } else {
                name = zone_name;
            }
            var body = {
                "name": name,
                "zone_type_id": zone_id,
                "active": true,
                "one": one,
                "multiple": multiple,
                "parent_zone_id": parent_zone_id,
                "attributes": attributes
            }
            var res = await fetchPost(`/vmi/companies/${company_id}/sites/${site_id}/zones`, body)

            // Make sure the parent is open so we can see the new zone after it is created.
            // TODO: TEST EDGE CASE FOR ZONE STARTING WITH NO CHILDREN.
            if (!expandedZones.includes(currentNode["id"])) {
                onExpand(currentNode["id"])
            }

            setTreeDirty(true);
            goTo(res[0]['id']);

            handleClose(false)
        } catch (error) {
            console.log(error)
            setZoneError(true)
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div className={binRadio === "1" ? classes.container2 : classes.container}>
            {isSubmitting ?
                <Loader height={250} noDecoration />
                :
                <>
                    <Dialog
                        open={zoneError}
                        onClose={() => { setZoneError(false) }}
                        aria-labelledby="responsive-dialog-title"
                        style={{ padding: "25px" }}
                    >
                        <ZoneError handleClose={setZoneError} />
                    </Dialog>
                    <MessageDialog open={messageDialog}
                        message={message}
                        status={messageStatus}
                        onClose={() => { setOpenMessage(false) }}
                    />
                    <span className={classes.title}>{I18n.get("add_zone").toUpperCase()}</span>
                    <div className={classes.close}>
                        <CloseIcon closeFunction={handleClose} />
                    </div>
                    <div className={classes.mainDiv}>
                        <span className={classes.typeFont} style={{ top: 10 }}>{I18n.get("zone_parent")}</span><span style={{ top: 10 }}>{currentNode ? currentNode["name"] : ""}</span>
                        <br /><br />
                        <span className={classes.typeFont}>{I18n.get("site_type2")}</span>
                        <div style={{ width: 307, marginBottom: 20 }}>
                            <CustomSelect
                                name={"type"}
                                value={zoneTypeSelected}
                                options={zonesMenu}
                                onChange={(e) => { selectZoneType(e.target.value); getZoneAttributes(e.target.value); setZoneName(""); setbinRadio("0") }}
                            />
                        </div>

                        {
                            ZONE_TYPES_WITH_MULTI_CREATE.includes(zoneTypeSelected) ?                    
                                <div>
                                    <span className={classes.typeFont} style={{ top: 5 }}>{I18n.get("number2")}</span>
                                    <div style={{ marginBottom: 30 }}>
                                        <div style={binRadio === "1" ? { width: 215, float: "left" } : { width: 300, float: "left" }}>
                                            <RadioGroup
                                                row
                                                name="view"
                                                value={binRadio}
                                                onChange={(e) => setbinRadio(e.target.value)}
                                            >
                                                <FormControlLabel
                                                    value={"0"}
                                                    control={<Radio color={"primary"} />}
                                                    label={I18n.get("one")}
                                                    classes={{ label: classes.radioLabel }}
                                                />
                                                <FormControlLabel
                                                    value={"1"}
                                                    control={<Radio color={"primary"} />}
                                                    label={I18n.get("multiple")}
                                                    classes={{ label: classes.radioLabel }}
                                                />
                                            </RadioGroup>
                                        </div>
                                        {binRadio === "1" ?
                                            <div style={{ float: "right", right: 60 }}>
                                                <input value={numBins} onChange={(e) => setNumBins(e.target.value)} type="number" style={{ width: 55, padding: 5, left: -15, top: 5, border: "1px solid #cccccc" }}></input>
                                            </div>
                                            : <></>}
                                    </div>
                                </div>
                                :
                                <></>
                        }

                        <div style={ZONE_TYPES_WITH_MULTI_CREATE.includes(zoneTypeSelected) ? { width: 300, marginTop: 50 } : { width: 300 }}>
                            {ZONE_TYPES_WITH_MULTI_CREATE.includes(zoneTypeSelected) ?
                                <></> :
                                <div>
                                    <span style={{ color: "red" }}>* </span><span className={classes.typeFont}>{I18n.get("frdefinition_name")}</span>
                                    <CustomInput id={zone_name} onChange={(e) => { setZoneName(e.target.value) }}></CustomInput>
                                </div>
                            }
                        </div>

                        {map(zone_attributes, (attribute, i) => (
                            attribute["id"] === ZONE_ATTR.UNIT_OF_MEASURE ?
                                <div style={{ marginTop: 22, width: 307 }} key={attribute['id']}>
                                    {attribute['required'] ? <span style={{ color: "red" }}>* </span> : <></>}<span className={classes.typeFont}>{attribute[`name_${language}`]}</span>
                                    <CustomSelect
                                        name={"type"}
                                        value={unitSelected}
                                        noSort={true}
                                        options={unitMeasurements}
                                        onChange={(e) => {
                                            setUnitSelected(e.target.value);
                                        }}
                                    />
                                </div>
                            : attribute["id"] === ZONE_ATTR.RESPONSIBILITY_CENTER ?
                                <div style={{ marginTop: 22, width: 307 }} key={attribute['id']}>
                                    {attribute['required'] ? <span style={{ color: "red" }}>* </span> : <></>}<span className={classes.typeFont}>{attribute[`name_${language}`]}</span>
                                    <CustomSelect
                                        name={attribute[`name_${language}`]}
                                        value={selectedResponsibilityCenter}
                                        noSort={true}
                                        options={ZONE_RESPONSIBILITY_CENTER_OPTIONS}
                                        onChange={(e) => {
                                            console.log(e.target.value)
                                            setSelectedResponsibilityCenter(e.target.value);
                                        }}
                                    />
                                </div>
                                :
                                <div style={{ marginTop: 22, width: 307 }} key={attribute['id']}>
                                    {attribute['required'] ? <span style={{ color: "red" }}>* </span> : <></>}<span className={classes.typeFont}>{attribute[`name_${language}`]}</span>
                                    <CustomInput
                                        id={attribute["id"].toString()}
                                        type={attribute["data_type"] === "float" || attribute["data_type"] === "integer" ? "number" : "text"}
                                        step={attribute["data_type"] === "float" ? "0.01" : ""}
                                    >
                                    </CustomInput>
                                </div>
                        ))}

                        <div className={classes.buttons}>
                            <Button onClick={() => { handleClose() }} color="primary">
                                {I18n.get("site_cancel")}
                            </Button>
                            <Button onClick={() => { handleZoneCreation() }} style={{ top: "-4px", left: "14px" }} variant="contained" color="primary">
                                {I18n.get("site_confirm")}
                            </Button>
                        </div>


                    </div>
                </>
            }
        </div>
    );

});

const mapStateToProps = (state) => {
    return {
        language: get(state, ["user", "language"]),
        zones: get(state, ["zones"]),
    };
};

export default withRouter(
    connect(mapStateToProps)(withStyles(styles)(ZoneCreation))
);
